import type { SelectItem } from "@fronterahealth/frontera-ui-components";

export const TRANSCRIBE_LANGUAGE_OPTIONS: SelectItem[] = [
  { id: "en", primary: "English" },
  { id: "es", primary: "Spanish" },
  { id: "hi", primary: "Hindi" },
  { id: "ar", primary: "Arabic" },
];

export const isTranscribeMime = (mimeType?: string | null): boolean =>
  !!mimeType && (mimeType.startsWith("audio/") || mimeType.startsWith("video/"));

export const getDefaultTranscribeLanguage = (isKuwaitUser: boolean): string => (isKuwaitUser ? "ar" : "en");

// Read the transcription language off a LearnerFile's metadata blob; undefined when
// absent or unparseable. Extracted from FileTableRow to keep its cognitive complexity down.
export const languageFromMetadata = (metadata?: string | null): string | undefined => {
  if (!metadata) return undefined;
  try {
    const parsed = typeof metadata === "string" ? JSON.parse(metadata) : metadata;
    return parsed && typeof parsed === "object" ? (parsed.language as string | undefined) : undefined;
  } catch {
    return undefined;
  }
};
